// Row size modifier for EntityLayout rows (`.el-row--single`, `.el-row--2`…).
// Pure, so the rule can be unit-tested without a DOM: a row is sized by the
// fields actually SHOWN in it, not by the fields declared for it — a field
// hidden by its `visible` predicate (display: none) must not leave a hole
// beside the one that remains.

export const ROW_SIZE_CLASSES = ['el-row--single', 'el-row--2', 'el-row--3', 'el-row--4'] as const;

export function rowSizeClass(shownFields: number): string {
    if (shownFields <= 1) return 'el-row--single';
    return `el-row--${Math.min(shownFields, 4)}`;
}
